import { render, staticRenderFns } from "./MinusCircle.vue?vue&type=template&id=e80ccea2&"
import script from "./MinusCircle.vue?vue&type=script&setup=true&lang=js&"
export * from "./MinusCircle.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports